export enum PaymentMethod {
  CASH = "CASH",
  MOMO = "MOMO",
  BANK_DEPOSIT = "BANK_DEPOSIT"
}

// Display labels for payment methods
export const PaymentMethodLabels: Record<PaymentMethod, string> = {
  [PaymentMethod.CASH]: "Cash",
  [PaymentMethod.MOMO]: "Mobile Money (MOMO)",
  [PaymentMethod.BANK_DEPOSIT]: "Bank Deposit"
};

/** Maps UI enum values to Order Management Service / GraphQL `PaymentMethod` names. */
export function toOmsPaymentMethod(
  method: string | undefined
): string | undefined {
  if (method == null || method === "") return undefined;
  switch (method) {
    case PaymentMethod.MOMO:
      return "MOBILE_MONEY";
    case PaymentMethod.BANK_DEPOSIT:
      return "BANK_TRANSFER";
    default:
      return method;
  }
}
